


function header(){

	$('.hamburger').click(function(){
		$(this).toggleClass('active');
		if($('.nav-popup').hasClass('active')){
			$('.nav-popup').removeClass('active');
			$('body').removeClass('popup-active');
			$('header .mobile').removeClass('popup-active');
			$('.header.header nav .mobile.events .events-hamburger').show();
		}else{
			$('.nav-popup').addClass('active');
			$('body').addClass('popup-active');
			$('header .mobile').addClass('popup-active');
			$('.header.header nav .mobile.events .events-hamburger').hide();
		}

		if ( $('.events-hamburger').hasClass('active') ) {
			$('.events-hamburger').trigger('click');
		}
	});

	$('.events-hamburger').on('click', function(e) {
		e.preventDefault();
		$(this).toggleClass('active');
		$('.header.header nav .mobile.events .events-menu').slideToggle();
	})

    $(window).scroll(function () {
        var scrollTop = $(window).scrollTop();

        if (scrollTop > 50) {
            $('header').addClass('scrolled');
        }
        else {
            $('header').removeClass('scrolled');
        }
    });	

	if($(window).width() > 990){
		$(window).scroll(function() {
			var scroll = getCurrentScroll();
			if((scroll % 3) == 0){ //Every 3rd pixel 
				if(scroll > 200){
					//Scrolling back up and not too close to the 'main' header
					$('header').addClass('scroll');
				}else{	
					//Scrolling down
					$('header').removeClass('scroll');
				}

			}
		});
	};




}

function showChildMenu($id){

	$('.open-children.menu-parent-wrapper-'+$id).toggleClass('active');

	$('#child-items-'+$id).toggleClass('active');

}



function headerScroll(){

	var scroll = getCurrentScroll();

	if((scroll % 3) == 0){ //Every 3rd pixel

		if(scroll > 200){ //Not at the top of the page

			if((scrollCache > scroll)){
				//Scrolling back up and not too close to the 'main' header
				$('.header').removeClass('scroll-back').addClass('scroll');
			}else{	
				//Scrolling down
				$('.header').removeClass('scroll').addClass('scroll-back');
			}

		}else{

			$('.header').removeClass('scroll').removeClass('scroll-back');

		}
		scrollCache = scroll;
		

	}
}

function getCurrentScroll() {
	return window.pageYOffset || document.documentElement.scrollTop;
}	


